import { crudActions } from "./CrudActions"

export default {
  ...crudActions("materials-usats"),
}
